import { useLocalization } from "@fluent/react";

import { Alert } from "@narmi/design_system";
import { InstitutionFeatures } from "byzantine/src/types/Institution.types";
import Feature from "byzantine/src/Feature";

import SudoDialog from "../../../../SudoDialog";
import { SudoProvider } from "../../../../SudoContext";
import { useUserFeatures } from "../../../../contexts/UserFeaturesContext";
import { CardImage } from "../../CardImage";
import LockCard from "./LockCard";
import CardActions from "./CardActions";
import CardOffers from "./CardOffers";

import styles from "./ManageACard.module.scss";

interface ManageACardProps {
  card: API.Card;
  updateCardStateById: (cardId: string, cardState: API.Card["state"]) => void;
  onUserDismiss: () => void;
}

const ManageACard = ({
  card,
  updateCardStateById,
  onUserDismiss,
}: ManageACardProps) => {
  const features = useUserFeatures() as InstitutionFeatures;
  const { l10n } = useLocalization();
  const isLocked = card?.state === "locked";
  const isShipped = card.state === "shipped";
  const isAtm = card.card_type === "atm";

  return (
    <SudoProvider basename={`cards/${card.id}`}>
      <div className={styles.cardImageContainer}>
        <CardImage
          name={card.name}
          textColor={card.text_color}
          size="large"
          isLocked={isLocked}
          cardId={card.id}
          image={card.image}
          lastFourDigits={card.last_four_digits}
          network={card.network}
          showSensitiveInfoButton={features?.olb_enable_sensitive_card_info}
        />
      </div>
      {card.state === "damaged" && (
        <div className={styles.bannerInfo}>
          <Alert isActive={true} isDismissable={false} kind="info">
            {l10n.getString("card-controls-damaged-card-drawer-description")}
          </Alert>
        </div>
      )}
      {!isShipped && (
        <LockCard
          state={card.state}
          isLocked={isLocked}
          cardId={card.id}
          updateCardStateById={updateCardStateById}
        />
      )}
      {!isAtm && (
        <>
          <CardActions card={card} onUserDismiss={onUserDismiss} />
          <Feature features={features} or={["card_linked_offers"]}>
            <CardOffers card={card} />
          </Feature>
        </>
      )}

      <SudoDialog />
    </SudoProvider>
  );
};

export default ManageACard;
